import React, { ComponentType, ReactElement } from 'react';

// Default watermark settings - defined outside to keep them consistent
const DEFAULT_TEXT = 'ai-2027.com';
const DEFAULT_OPACITY = 50;
const DEFAULT_FONT_SIZE = 'base';
const DEFAULT_FONT_FAMILY = 'font-mono';
const DEFAULT_COLOR = 'text-gray-400';
const DEFAULT_Z_INDEX = 10;

/**
 * Higher-order component that wraps a component with a watermark
 * @param WrappedComponent The component to wrap with a watermark
 * @param verticalShift Optional vertical shift in pixels (positive = down)
 * @param bottomPadding Optional padding below the component (in pixels)
 * @returns A new component with the watermark applied
 */
function WatermarkWrapper<P extends object>(
  WrappedComponent: ComponentType<P>,
  verticalShift: number = 0,
  bottomPadding: number = 0
): React.FC<P> {
  // Return the wrapped component
  return function WithWatermark(props: P): ReactElement {
    return (
        <div className="relative overflow-x-auto overflow-y-hidden" style={{ marginBottom: `${bottomPadding}px` }}>
          {/* Original component */}
          <WrappedComponent {...props} />
          
          {/* Watermark overlay at the bottom-right */}
          <div 
            className={`absolute bottom-0 right-0 ${DEFAULT_FONT_FAMILY} ${DEFAULT_COLOR} opacity-${DEFAULT_OPACITY} text-${DEFAULT_FONT_SIZE} pb-0 pr-0.5`}
            style={{ 
              lineHeight: 1,
              transform: `translateY(${verticalShift}px)` 
            }}
          >
            {DEFAULT_TEXT}
          </div>
        </div>
    );
  };
}

export default WatermarkWrapper;